module.exports = __webpack_public_path__ + "img/icon_transcript_close.svg";